import { sort } from 'd3';
import { apiClient } from '../_helpers';

export const tagService = {
  getAll,
  searchTags,
  getById,
  addTag,
  updateTag,
  deleteTag,
  getSelectList
};

async function getAll() {
  try {
    const response = await apiClient(`tags/`)
      .get();
    return response.data;
  } catch (error) {
    return error;
  }
}

async function getSelectList(dietary) {
  try {
    const response = await apiClient(`tags/selectlist?dietary=${dietary}`)
      .get();
    return response.data;
  } catch (error) {
    return error;
  }
}

async function searchTags(params) {

  var ps = "";
  var ccat = "";
  if(params.query)
  {
    ps = ps + "searchQuery=" + params.query;
    ccat = "&";
  }
  if(params.pageSize)
  { 
    ps = ps + ccat + "pageSize=" + params.pageSize;
    ccat = "&";
  }
  if(params.page)
  {
    ps = ps + ccat + "pageNumber=" + params.page;
    ccat = "&";
  }
  try {
    const response = await apiClient(`tags?${ps}`).get();
    return response.data;
  } catch (error) {
    return error;
  }
}
async function getById(id) {
  try {
    const response = await apiClient('tags/')
      .get(`${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
}
async function addTag(newTag) {
  try {
    const response = await apiClient('tags/')
      .post('', `${JSON.stringify(newTag)}`);
    return response.data;
  } catch (error) {
    return error;
  }
}
async function updateTag(newTag) {
  try {
    const response = await apiClient(`tags/${newTag.id}`)
      .put('', `${JSON.stringify(newTag)}`);
    return response.data;
  } catch (error) {
    return error;
  }
}
async function deleteTag(tag) {
  try {
    const response = await apiClient(`tags/${tag}`)
      .delete();
    return response.data;
  } catch (error) {
    return error;
  }
}